import * as React from 'react';
import { uniqueId } from 'lodash';
import Icon from '../Icon';

export interface IControlStarProps {
    /** Label */
    value: number;
    /** Handle change */
    setScore: (id) => void;
    /** Is checked */
    checked: boolean;
}

const ControlStar: React.FunctionComponent<IControlStarProps> = (props) => {
    const id = uniqueId('star');
    return (
        <React.Fragment>
            <input value={props.value} id={id} onChange={() => props.setScore(props.value)} checked={props.checked} type="radio" name="rating" className="visuallyhidden"/>
            <label htmlFor={id}>
                <span className="visuallyhidden">{props.value}</span>
                { props.value === 0 ? (
                    <Icon kind="remove" width={11} height={11}/>
                ) : (
                    <Icon kind="star2" width={18} height={17}/>
                )}
            </label>
        </React.Fragment>
    );
};

ControlStar.displayName = 'ControlStar';

export default ControlStar;
